var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.getLoadingState,"fixed":false,"no-wrap":true,"opacity":"0.6","spinner-type":"border","spinner-variant":"primary","variant":"black"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }